import RadioGroup from '@standardsdigital/ui-components/RadioGroup';
import RadioGroupItem from '@standardsdigital/ui-components/RadioGroupItem';
import { useTranslation } from 'react-i18next';
import FieldStatusWrapper from 'components/global/FieldStatusWrapper/FieldStatusWrapper';

interface PriceFactorModeRadioProps {
  value: boolean;
  onChange: (value: boolean) => void;
  isDirty: boolean;
  disabled: boolean;
}

function PriceFactorModeRadio({
  value,
  onChange,
  isDirty,
  disabled,
}: Readonly<PriceFactorModeRadioProps>) {
  const { t } = useTranslation();

  return (
    <FieldStatusWrapper isDirty={isDirty}>
      <RadioGroup
        label={t('serviceLevels.form.priceFactorMode')}
        layout="vertical"
        value={String(value)}
        onValueChange={(nextValue) => onChange(nextValue === 'true')}
        disabled={disabled}
      >
        <RadioGroupItem
          value="true"
          label={t('serviceLevels.form.priceFactorModeOptions.serviceLevel')}
          disabled={disabled}
        />
        <RadioGroupItem
          value="false"
          label={t('serviceLevels.form.priceFactorModeOptions.attributeBased')}
          disabled={disabled}
        />
      </RadioGroup>
    </FieldStatusWrapper>
  );
}

export default PriceFactorModeRadio;
